/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Patient Search criteria view model passed from client
 */
export interface PatientSearchCriteriaIntegrationViewModel {
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size.  For example, if Page = 2 and PageSize = 25, the results contain matching patients 26-50, if available.
   */
  pageSize?: number;
  /**
   * Patient account number.  Must match exactly.
   */
  accountNumber?: string | null;
  /**
   * Patient MRN.  Must match exactly.
   */
  medicalRecordNumber?: string | null;
  /**
   * Patient last name.  Must match exactly.
   */
  lastName?: string | null;
  /**
   * Patient first name.  Must match exactly.
   */
  firstName?: string | null;
  /**
   * Patient birth date.  Must match exact day.
   */
  birthDate?: string | null;
}
